// Single source of truth for detecting/parsing the "@ Shoob" tag that
// reformat-schedules.js appends to a day key when a schedule belongs to
// school 1075 (the in-house Shoob studio "school" record). Was previously
// re-derived ad hoc (`.split('@').length > 1`, `.includes('@ Shoob')`) in
// several places and had drifted out of sync in one of them.
export const SHOOB_DAY_SUFFIX = ' @ Shoob'

export const isShoobDayKey = (dayKey) => !!dayKey && dayKey.includes(SHOOB_DAY_SUFFIX)

export const stripShoobDaySuffix = (dayKey) => dayKey.split('@')[0].trim()
